import { createRouter, createWebHistory } from 'vue-router'
import { config } from '../../nextround'
import { routesFactory } from '@madxnl/mrrabbit'
import UserInsights from '../components/UserInsights.vue'
import UsersListPage from '../components/UsersListPage.vue'
import WorkoutInsights from '../components/WorkoutInsights.vue'
import WorkoutsListPage from '../components/WorkoutsListPage.vue'
import ListPage from '../components/ListPage.vue'

const routes = routesFactory(config)
for (const route of routes) {
  if (config.some(item => item.name === route.name)) route.component = ListPage
}
const usersRoute = routes.find(route => route.name === 'Users')
const usersConfig = config.find(item => item.name === 'Users')

if (usersRoute == null || usersConfig == null) {
  throw new Error('Users backoffice route is not configured')
}

const generatedUsersListPage = usersRoute.component
usersRoute.component = UsersListPage
usersRoute.props = {
  config: usersConfig.listPage,
  listComponent: generatedUsersListPage,
}

routes.push({
  path: '/users/insights',
  name: 'User insights',
  component: UserInsights,
})

const workoutsRoute = routes.find(route => route.name === 'Workouts')
const workoutsConfig = config.find(item => item.name === 'Workouts')

if (workoutsRoute == null || workoutsConfig == null) {
  throw new Error('Workouts backoffice route is not configured')
}

const generatedWorkoutsListPage = workoutsRoute.component
workoutsRoute.component = WorkoutsListPage
workoutsRoute.props = {
  config: workoutsConfig.listPage,
  listComponent: generatedWorkoutsListPage,
}

routes.push({
  path: '/workouts/insights',
  name: 'Workout insights',
  component: WorkoutInsights,
})

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
